import React, { Component } from 'react';
import { getVideo, eventVideo } from '../../actions/watchActions';
import ReactPlayer from 'react-player';
import Footer from '../../components/Footer';
import './styles_play.css';

export default class Play extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      urlVideo: null,
      campaign_video: null,
      isLoading: true,
      videoAvailable: false,
      infoData: {},
      finished: false,
      timeRemaining: 0,
      countdownActive: false,
      mediaType: null,
      type: null,
      showEndButton: false
    };
    this.campaign_id = props.campaign_id;
    this._onEnded = this._onEnded.bind(this);
  }

  cleanUrl(url) {
    let post = { campaign_id: this.campaign_id, type_page: "Video" };
    let tags = url.match(/({{[a-z_0-9]+}})/gi);
    let query_string = window.location.search.replaceAll("%3C", "").replaceAll("%3E", "").replaceAll('(', '').replaceAll(')', '');
    let params = new URLSearchParams(query_string);

    for (let pair of params.entries()) {
      post[pair[0]] = pair[1];
    }

    tags?.map((val) => {
      url = url.replace(val, params.get(val.match(/[a-z_0-9]+/)[0]));
    });

    const redirect_url = new URL(url);
    let searchParams = new URLSearchParams(redirect_url.search);
    for (let pair of searchParams.entries()) {
      post[pair[0]] = pair[1];
    }

    eventVideo(post).then(() => {
      window.location.href = url;
    });
  }

  async componentDidMount() {
    let response = await getVideo(this.campaign_id);
    const element = response.data;

    this.setState({ infoData: element, videoAvailable: true, isLoading: false });

    if (element.viewed_at == null) {
      this.loadMedia(element);
    } else {
      this.setState({ finished: true });
    }

    gtag('event', 'page_view', {
      page_title: 'Vídeo ' + element.name,
      page_location: window.location.href
    });
  }

  loadMedia(infoData) {

    const url = infoData.campaign_video;
    const ext = url.split('.').pop().toLowerCase();

    let mediaType = 'video';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) mediaType = 'image';
    else if (['mp3', 'wav', 'ogg', 'aac'].includes(ext)) mediaType = 'audio';
    else if (url.startsWith('http') && !ReactPlayer.canPlay(url)) mediaType = 'url';

    
  }


  startCountdown(durationSeconds) {
    this.setState({ timeRemaining: durationSeconds, countdownActive: true });

    this.timer = setInterval(() => {
      this.setState(prev => {
        if (prev.timeRemaining <= 1) {
          clearInterval(this.timer);
          return { timeRemaining: 0, countdownActive: false, showEndButton: true };
        }
        return { timeRemaining: prev.timeRemaining - 1 };
      });
    }, 1000);
  }

  _onEnded() {
    const { infoData } = this.state;
    let url_redirect = infoData.redirect_complete;

    if (infoData.qtdViews > 450) {
      url_redirect = infoData.redirect_full;
    }

    if (infoData.max_views != null && infoData.redirect_full && infoData.total_views > infoData.max_views) {
      url_redirect = infoData.redirect_full;
    }

    this.setState({ finished: true });
    gtag('event', 'page_view', {
      page_title: 'Vídeo Visualizado ' + infoData.name,
      page_location: window.location.href + '?finished=true'
    });

    this.cleanUrl(url_redirect);
  }

  renderMedia() {
    const { type, campaign_video } = this.state.infoData;

    if (type === 'image') {

      return (
        <img
          src={campaign_video}
          alt="Imagem da campanha"
          style={{ maxWidth: '100%'}}
        />
      );
    }

    if (type === 'audio') {
      return (
        <div className="text-center">
          <audio src={campaign_video} controls autoPlay onEnded={this._onEnded} />
        </div>
      );
    }

    if (type === 'url') {
      return (
        <iframe
          src={campaign_video}
          title="Conteúdo da campanha"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          onContextMenu={(e) => e.preventDefault()} 
        ></iframe>
      );
    }

    return (
      <div className="player-wrapper">
        <ReactPlayer
          className="react-player"
          playing={true}
          url={campaign_video}
          width="100%"
          onEnded={this._onEnded}
          crossOrigin="anonymous"
        />
      </div>
    );
  }

  render() {
    const { finished, infoData, isLoading, videoAvailable, countdownActive, timeRemaining, showEndButton, mediaType } = this.state;

    if (isLoading) {
      return <div className="text-center py-4"><span className="fa fa-refresh fa-spin fa-4x"></span></div>;
    }

    if (finished) {
      return (
        <div className="container text-center py-5">
          <h3>Obrigado por participar!</h3>
        </div>
      );
    }

    return (
      <div>
        <nav className="navbar fixed-top navbar-expand-lg" id="sectionsNav">
          <div className="container-fluid">
            <div className="navbar-translate mb-2 mt-2">
              <img src="/assets/img/logo.png" height="55" alt="Brandful" />
            </div>
          </div>
        </nav>

        <ol className="breadcrumb py-4">
          <li className="breadcrumb-item font-weight-bold">Painelista | Bem-vindo</li>

          {(this.state.infoData.type === 'image' || this.state.infoData.type === 'url') && showEndButton && (
              <div className="ml-auto">
                <button className="btn btn-success" onClick={this._onEnded}>Concluir</button>
              </div>
            )}
        </ol>

        <div className="container-fluid">
          <h3 className="pt-4" style={{ overflowWrap: 'break-word' }}><strong>{this.state.infoData.name}</strong></h3>

          {/* <p>Assista ao conteúdo abaixo para participar da pesquisa.</p>

          <ul className="list-unstyled text-muted font-weight-bold">
            <li>Passo 1: Assista ou aguarde o tempo necessário.</li>
            <li>Passo 2: Clique no botão (se aplicável) ao final.</li>
            <li>Passo 3: Aguarde a mensagem de sucesso.</li>
          </ul>
        </div>

        {videoAvailable && infoData.viewed_at === null ? (
          <div className="container-fluid pb-4">
          </ul> */}
        </div>

        {videoAvailable && this.state.infoData.viewed_at === null ? (
          <div className="container d-flex flex-column align-items-center justify-content-center" style={{ height: '70vh' }}>
            {this.renderMedia()}
          </div>
        ) : (
          <div className="container d-flex flex-column align-items-center justify-content-center" style={{ height: '70vh' }}>
            <div className="alert alert-info text-center">Você já participou desse estudo</div>
          </div>
        )}

        <Footer />
      </div>
    );
  }
}